import { render, staticRenderFns } from "./I2SalesDashboard.vue?vue&type=template&id=937769d4&scoped=true&"
import script from "./I2SalesDashboard.vue?vue&type=script&lang=js&"
export * from "./I2SalesDashboard.vue?vue&type=script&lang=js&"
import style0 from "./I2SalesDashboard.vue?vue&type=style&index=0&id=937769d4&scoped=true&lang=css&"
import style1 from "./I2SalesDashboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937769d4",
  null
  
)

export default component.exports